import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import VideoModalTwo from '../../components/video-modal-two'
import TeamTwo from '../../components/team-two'
import Footer from '../../components/footer'
import BlogOne from '../../components/blog-one'

import bg1 from '../../assets/images/contraction/06.jpg'
import heroImg from '../../assets/images/contraction/07.png'
import aboutImg from '../../assets/images/contraction/01.jpg'

import { contractionFeature, contractionImage } from '../../data/data'

import {FiCamera} from '../../assets/icons/vander'

import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';

export default function IndexContraction() {
  let [activeIndex, setActiveIndex] = useState(0);
  let [isOpen, setIsOpen] = useState(false);

  const onHandleClick = (index) =>{
    setIsOpen(true)
    setActiveIndex(index)
  }
  return (
    <>
     <Navbar navLight={true}/> 

    <section className="bg-hero d-flex align-items-center pb-0" style={{backgroundImage:`url(${bg1})`}}>
      <div className="bg-overlay" style={{opacity: '0.8'}}></div>
      <div className="container">
          <div className="row justify-content-center align-items-center mt-5">
              <div className="col-lg-7 col-md-7">
                  <div className="title-heading mt-4">
                      <h1 className="heading text-white fw-semibold title-dark display-4 mb-3">We are for you to be <br/> the <span className="text-primary fw-bold">Construction.</span></h1>
                      <p className="para-desc text-light title-dark">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <div className="mt-4 pt-2">
                          <Link to="/contact" className="btn btn-primary mb-2 me-2"><i className="mdi mdi-phone"></i> Contact Us</Link>
                      </div>
                  </div>
              </div>
              <div className="col-lg-5 col-md-5">
                  <img src={heroImg} className="img-fluid" alt=""/>
              </div>
          </div>
      </div>
    </section>

    <section className="section"> 
      <div className="container">
          <div className="row align-items-center">
              <div className="col-lg-5 col-md-6 order-lg-2 order-md-2">
                  <div className="position-relative">
                      <img src={aboutImg} className="img-fluid shadow rounded" alt=""/>
                      <VideoModalTwo/>
                  </div>
              </div>

              <div className="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0 order-lg-1 order-md-1">
                  <div className="section-title ms-md-4">
                      <h5 className="text-primary">About Us</h5>
                      <h4 className="title mb-4">Construction Designer</h4>
                      <p className="text-muted">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <p className="text-muted">It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text. This might also explain why one can now find slightly different versions. Due to the age of the Lorem Ipsum text there are no copyright issues to contend with.</p>
                      <Link to="#" className="btn btn-outline-primary mt-2"> Read More</Link>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section bg-light">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Our Services</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {contractionFeature.map((item,index)=>{
              let Icon = item.icon
              return(
                  <div className="col-lg-3 col-md-4 col-12 mt-4 pt-2" key={index}>
                      <div className="feature p-3 py-5 rounded text-center">
                          <Icon className="h1 text-primary"/>
                          <div className="content">
                              <h4 className="title mt-3">{item.title}</h4>
                              <p className="text-muted mt-2 mb-0">{item.desc}</p>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>
    </section>

    <section className="section">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Our Architecture</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
          <TeamTwo/>
      </div>
    </section>

    <div className="container mb-60 mt-60" id="contactme">
      <div className="bg-dark bg-cta-dark rounded p-md-5 p-4 p-sm-0 shadow">
          <div className="row align-items-center">
              <div className="col-sm-7">
                  <div className="text-sm-start">
                      <h4 className="text-white title-dark">Ready to start your project ?</h4>
                      <p className="text-white-50 para-desc para-dark mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>

              <div className="col-sm-5 mt-4 mt-sm-0">
                  <div className="text-sm-end">
                      <Link to="#" className="btn btn-outline-primary"><i className="mdi mdi-phone-outline"></i> Contact Now</Link>
                  </div>
              </div>
          </div>
      </div>
    </div>

    <section className="section bg-light">
      <div className="container">
          <div className="row ju">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Our Home Products</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row justify-content-center">
              <div className="col-lg-11 col-sm-10">
                  <div className="row">
                    {contractionImage.map((item,index)=>{
                      return(
                          <div className="col-lg-6 col-md-6 col-12 mt-4" key={index}>
                              <div className="card shadow border-0 portfolio portfolio-classic portfolio-primary rounded overflow-hidden">
                                  <div className="card-img position-relative">
                                      <img src={item} className="img-fluid" alt=""/>
                                      <div className="card-overlay"></div>
                                      <div className="pop-icon">
                                          <Link to="#" className="btn btn-pills btn-icon lightbox" onClick={()=>onHandleClick(index)}><FiCamera className=""/></Link>
                                      </div>
                                      {isOpen && (
                                          <Lightbox
                                            mainSrc={contractionImage[activeIndex]}
                                            nextSrc={contractionImage[(activeIndex + 1) % contractionImage.length]}
                                            prevSrc={contractionImage[(activeIndex + contractionImage.length - 1) % contractionImage.length]}
                                            onCloseRequest={() => setIsOpen(false)}
                                            onMovePrevRequest={() =>setActiveIndex((activeIndex + contractionImage.length - 1) % contractionImage.length)
                                            }
                                            onMoveNextRequest={() =>setActiveIndex((activeIndex + 1) % contractionImage.length)
                                            }
                                          />
                                        )}
                                  </div>
                              </div>
                          </div>
                      )
                    })}
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section">
      <div className="container mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Latest Blog & News</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
          <BlogOne/>
      </div>
    </section>

    <Footer/>
    </>
  )
}
